import * as React from 'react';
import type { ComponentType } from 'react';

export type GetRenderToolbarOptions = Record<any, any>;

export type RenderToolbarProps = (toolbarProps?: any) => React.ReactElement;

export const getRenderToolbar = <
  T,
  PluginOptions extends {
    component: ComponentType<T>;
  } = {
    component: ComponentType<T>;
  },
>({
  component: Component,
  ...pluginOptions
}: PluginOptions): RenderToolbarProps =>
  function GetRenderToolbar(toolbarProps) {
    return <Component {...toolbarProps} {...pluginOptions} />;
  };
